import { LogoLoading } from "./LogoLoading";

// First-paint boot surface (the client splash and the root Suspense
// fallback). No caption: the boot splash, this splash, and the in-app loaders
// swap as the app comes up, and differing captions flickered on/off between
// them — keeping all layers to the bare logo makes them read as one loader.
export const SplashScreenFallback = () => {
  return (
    <div class="fixed inset-0 z-9999 bg-canvas">
      <LogoLoading />
    </div>
  );
};
